interface AvatarProps {
  src?: string | null;
  name?: string;
  size?: "tiny" | "small" | "large";
  onClick?: () => void;
}

function getInitials(name: string): string {
  return name
    .split(/\s+/)
    .map((w) => w[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

export function Avatar({ src, name = "", size = "small", onClick }: AvatarProps) {
  const cls = `avatar avatar-${size}`;

  return (
    <div className={cls} onClick={onClick} style={onClick ? { cursor: "pointer" } : undefined} role={onClick ? "button" : undefined} tabIndex={onClick ? 0 : undefined} aria-label={onClick ? `Change photo for ${name}` : undefined}>
      {src ? (
        <img src={src} alt={name} className="avatar-img" />
      ) : (
        <span className="avatar-initials">{getInitials(name)}</span>
      )}
    </div>
  );
}
